import { Link, Typography } from "@mui/material";
import { useBranding } from "../../branding/BrandingProvider";
import { formatBuildLine } from "../../config/buildInfo";

/** "https://www.teleheadache.com" -> "teleheadache.com": how people say a site's name. */
const siteName = (url: string) => new URL(url).hostname.replace(/^www\./, "");

export function Copyright() {
  const brand = useBranding();
  return (
    <>
      {/* The way back to the brand's public website, on every screen — signed out (this component is
          what each of those renders on its own) and signed in (Footer renders it too). New tab, so
          a patient part-way through something in the portal doesn't lose their place. */}
      {brand.websiteUrl && (
        <Typography variant="body2" align="center" sx={{ mb: 0.5 }}>
          <Link href={brand.websiteUrl} target="_blank" rel="noopener noreferrer">
            Visit {siteName(brand.websiteUrl)}
          </Link>
        </Typography>
      )}
      <Typography
        variant="body2"
        align="center"
        sx={{
          // Explicit, not inherited: inherited text took the OUTER theme's body colour, which on
          // CerebraLinked's dark sign-in page (dark theme inside a light shell) was near-black.
          color: "text.primary",
          fontWeight: 500,
        }}
      >
        © {new Date().getFullYear()} {brand.copyrightHolder} • All rights
        reserved • Powered by CerebraSphere
      </Typography>
      {/* The build line lives HERE, not in Footer.tsx, because <Copyright /> is what every
          unauthenticated screen renders on its own — login, registration, MFA setup, the external
          provider register page. Footer.tsx is mounted only in the authenticated shell, so putting
          it there would leave it off exactly the screens a stuck user is looking at when they call.

          `data-testid` so a test can assert its presence without matching on a version string that
          changes every build. */}
      <Typography
        variant="caption"
        align="center"
        component="p"
        data-testid="build-line"
        sx={{ color: "text.secondary", mt: 0.5 }}
      >
        {formatBuildLine()}
      </Typography>
    </>
  );
}
